import React from 'react';
import { motion } from 'framer-motion';
import { PenLine } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function PostCtaSection() {
  return <section className="bg-noir-950 py-14 sm:py-24" data-id="element-188" data-mp="28tzxqm9bg5w3">
      <div className="container" data-id="element-189" data-mp="1uzz8qk861x8x">
        <div className="mx-auto grid max-w-5xl gap-3.5 sm:gap-5 lg:grid-cols-2" data-id="element-190" data-mp="1uyo4kjat6nha">
          <motion.div initial={{
          opacity: 0,
          y: 26
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} className="rounded-2xl border border-cream/10 bg-noir-800/60 p-6 sm:p-10" data-id="element-191" data-mp="1z0st53megtx2">
            <p className="text-[11px] font-bold uppercase tracking-widest2 text-gold-400" data-id="element-192" data-mp="1g3i0i1v9wyql">
              Piénsalo así
            </p>
            <p className="mt-4 font-display text-lg leading-snug text-cream sm:mt-5 sm:text-2xl" data-id="element-193" data-mp="36gyzvcis261d">
              Si este bundle te ayuda a tener una sola mejor conversación, una sola
              primera cita que no arruines, o a leer una sola señal correctamente...
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-cream/65 sm:mt-5" data-id="element-194" data-mp="16xa578l2vu8d">
              ¿No valió mucho más que $9.99? La respuesta obvia es sí.{' '}
              <span className="font-semibold text-gold-400" data-id="element-195" data-mp="1lnpnaei76m2b">Y lo sabes.</span>
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 26
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.6,
          delay: 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="rounded-2xl border border-crimson-500/25 bg-wine-900/30 p-6 sm:p-10" data-id="element-196" data-mp="swzblxsdw1ji">
            <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest2 text-crimson-500" data-id="element-197" data-mp="xv9420mq4o1f">
              <PenLine className="h-3.5 w-3.5" aria-hidden="true" data-id="element-198" data-mp="2e8haq7fg2s1k" />
              P.D.
            </p>
            <div className="mt-4 space-y-3.5 text-[15px] leading-relaxed text-cream/70 sm:mt-5 sm:space-y-4" data-id="element-199" data-mp="29dbo16e7x9cf">
              <p data-id="element-200" data-mp="2ggrwtjuc3yr0">
                Si estás leyendo esto y aún no has comprado, te voy a ser completamente
                honesto:
              </p>
              <p className="font-display text-lg font-semibold text-cream sm:text-xl" data-id="element-201" data-mp="2qdmuy1mp3x4r">
                El precio de $9.99 no estará aquí mañana.
              </p>
              <p data-id="element-202" data-mp="1xnxvhspmw559">
                Y los mismos problemas que tienes hoy — no saber qué decir, no leer las
                señales, arruinar citas por nervios — van a seguir ahí si no haces algo
                diferente. Este bundle es ese algo diferente.
              </p>
              <p className="text-cream/55" data-id="element-203" data-mp="27k0skk5mpdlc">
                Por menos de $10. Sin riesgo. Con garantía de 30 días.
              </p>
              <p className="font-semibold text-gold-400" data-id="element-204" data-mp="1exoe3bla06sz">
                La pregunta no es si puedes permitírtelo. La pregunta es si puedes
                permitirte no tenerlo.
              </p>
            </div>
            <CtaButton size="md" className="mt-6 w-full sm:mt-8" data-id="element-205" data-mp="11ohn6qprx7s">
              Comprar ahora — $9.99
            </CtaButton>
          </motion.div>
        </div>
      </div>
    </section>;
}